import { CometChat } from '@cometchat-pro/chat';
import { RcFile } from 'antd/lib/upload';

import { chatListRequest } from 'hooks/useCometChat';
import Users from 'api/classes/Users';

interface ICometChatAuthTokenResponse {
  success: boolean,
  data?: { authToken?: string },
  error?: any
}

// Fetches a short-lived, per-user CometChat auth token from the backend.
// The full-access AUTH_KEY must never reach the client.
export const getCometChatAuthTokenRequest = async(): Promise<ICometChatAuthTokenResponse> =>
  await Users.getCometChatAuthToken();

const messagesCommonRequest = async(request: any) => {
  try {
    const data = await request;

    return { success: true, data };
  } catch (error: any) {
    return { success: false, error: error };
  }
};

export const getChatsListRequest = async() => await messagesCommonRequest(chatListRequest.fetchNext());

export const getSingleChatRequest = async(id: string) =>
  await messagesCommonRequest(CometChat.getConversation(id, CometChat.RECEIVER_TYPE.USER));

export const sendMessageRequest = async(id: string, message: string | RcFile) => {
  const isFileMessage = typeof message !== 'string';
  let newMessage;

  if (isFileMessage) {
    newMessage = new CometChat.MediaMessage(id, message, CometChat.MESSAGE_TYPE.FILE, CometChat.RECEIVER_TYPE.USER);
  } else {
    newMessage = new CometChat.TextMessage(id, message, CometChat.RECEIVER_TYPE.USER);
  }

  return await (messagesCommonRequest(CometChat.sendMessage(newMessage)));
};

interface IGerActiveChatMessagesResponse {
  success: boolean,
  data?: CometChat.BaseMessage[] | [],
  error?: any
}

export const getActiveChatMessagesRequest = async(activeId: string, messageId?: number) => {
  const messagesRequest = new CometChat.MessagesRequestBuilder()
    .setUID(activeId)
    .setMessageId(messageId)
    .setLimit(30)
    .build();

  const {
    success,
    data,
    error,
  }: IGerActiveChatMessagesResponse = await messagesCommonRequest(messagesRequest.fetchPrevious());

  if (success) {
    return { success, data, error };
  }
};

export const getUserDetailsRequest = async(id: string) => await messagesCommonRequest(CometChat.getUser(id));

export const updateUserRequest = (id: string, name: string) => {
  const user = new CometChat.User(id);

  user.setName(name);
  messagesCommonRequest(CometChat.updateCurrentUserDetails(user));
};

